import React from 'react'
import FooterButtons from '../../components/form/FooterButtons/FooterButtons'
import { Form, Spinner } from 'react-bootstrap'
import Disclaimer from '../../components/BridgingFinance/Disclaimer'
import { useMutation } from 'react-query'
import axios from 'axios'
import { getAPIUrl } from '../../api/API'
import { ActiveReport } from '../../components/kyc/KycPopupComponent'
import { API_ERROR_MESSAGE } from '../../utils/Constants'
interface BridgingFinanceProps {
  setShow: (value: boolean) => void
  setActiveReport: (value: ActiveReport) => void
  setShowDropdownBridging: (value: boolean) => void
  setIsError: (value: boolean) => void
  setErrorMessage: (value: string) => void
}

const BridgingFinance: React.FC<BridgingFinanceProps> = ({
  setShow,
  setActiveReport,
  setShowDropdownBridging,
  setIsError,
  setErrorMessage,
}) => {
  const { mutate: acceptDisclaimer, isLoading: isLoadingApproval } =
    useMutation(
      'bridging-disclaimer-approval',
      async () => {
        //make post call to /Disclaimer/accept-disclaimer
        const { data } = await axios.post(
          `${getAPIUrl()}/BridgingFinance/BridgeFinanceStats`,
          {
            disclaimerName: 'BridgingFinance',
          },
          {
            headers: {
              Authorization: `Bearer ${await sessionStorage.getItem('jwt')}`,
            },
          },
        )
        return data
      },
      {
        onSuccess: (data) => {
          // setActiveReport('BRIDGE_TWO')
          window.open(
            'https://generalfinance.co.za/GeneralFinance/Home?mid=Q01B',
            '_blank',
            'noopener,noreferrer',
          )
          setShowDropdownBridging(true)
        },
        onError: (err) => {
          setIsError(true)
          setErrorMessage(API_ERROR_MESSAGE)
        },
      },
    )

  const handleAccept = async () => {
    await acceptDisclaimer()
  }

  const subHeaderText = (
    <span>
      If you're tired of waiting for Estate Agent's commission or the proceeds
      from
      <br /> a registration of a bond/sale, let{' '}
      <strong>
        <span style={{ fontWeight: 'bold' }}>
          GENERAL FINANCE(GenFin) do the waiting.
        </span>
      </strong>
    </span>
  )

  return (
    <div>
      <div>
        {isLoadingApproval && (
          <>
            <div className="spinner-container">
              <Spinner
                as="span"
                animation="border"
                variant="dark"
                role="status"
                aria-hidden="true"
              ></Spinner>
              <span> </span>
            </div>
          </>
        )}
        <Form.Group className="mb-3">
          <Form.Label className="darkGreyTextHeaders">
            BRIDGING FINANCE
          </Form.Label>
          <div className="d-flex">
            <Form.Label className="lightGreyText" style={{ flex: '75%' }}>
              {subHeaderText}
            </Form.Label>
          </div>
          <div className="greyLine"></div>
        </Form.Group>
      </div>
      <Form.Group style={{ paddingTop: '15px', paddingBottom: '10px' }}>
        <ul
          style={{
            fontSize: '12px',
            fontFamily: 'Montserrat,sans-serif!important',
          }}
        >
          <li>
            GenFin will pay you up to <strong>90% of the amount due</strong> to
            you <strong>within 24 hours!</strong>
          </li>
          <br />
          <li>
            Currently the interest charge for Estate Agents is R0.91 per day for
            every <br /> thousand Rands financed and R1.20 for all other
            Clients.
          </li>
          <br />
          <li>
            By way of example, GenFin would finance a transaction of R25 000
            over a <br /> period of 30 days for only R682.50 (plus a once-off
            R415 contract initiation fee)
          </li>
        </ul>

        <p
          style={{
            paddingLeft: '21px',
            fontSize: '12px',
            fontFamily: 'Montserrat,sans-serif!important',
          }}
        >
          ....as you can see the rates are extremely competitive!!
        </p>

        <p
          style={{
            marginLeft: '17px',
            fontSize: '12px',
            fontFamily: 'Montserrat,sans-serif!important',
          }}
        >
          Unfortunately, GenFin can't entertain Bridging Finance for new
          developments.
        </p>
      </Form.Group>
      <FooterButtons
        setShow={setShow}
        handleSearch={handleAccept}
        searchChildren={'Continue'}
      />
      <Disclaimer />
    </div>
  )
}

export default BridgingFinance
